export const GAME_NAME = 'Encantados';
export const DEFAULT_SERVER_PORT = 8000;
export const DEFAULT_SERVER_URL = 'http://localhost:8000';